import angular from 'angular';
import smsTemplatesManagementModal from './smsTemplatesManagementModal';

export default angular
  .module('components.smsTemplatesManagementModal', [])
  .component('smsTemplatesManagementModal', smsTemplatesManagementModal).name;
